import React from 'react'
import {Direction} from '../Cell'
export type Colorable = {color:string}
export type Directed = {A:Direction,B?:Direction}
export const PathDown=({color}:Colorable)=><svg viewBox="0 0 1 1">
    <polygon points="0.4,1 0.6,1 0.6,0.5 0.4,0.5" fill={color}/>
</svg>
export const PathUp=({color}:Colorable)=><svg viewBox="0 0 1 1">
<polygon points="0.4,0 0.6,0 0.6,0.5 0.4,0.5" fill={color}/>
</svg>
export const PathLeft=({color}:Colorable)=><svg viewBox="0 0 1 1">
<polygon points="0,0.4 0,0.6 0.5,0.6 0.5,0.4" fill={color}/>
</svg>
export const PathRight=({color}:Colorable)=><svg viewBox="0 0 1 1">
<polygon points="1,0.4 1,0.6 0.5,0.6 0.5,0.4" fill={color}/>
</svg>
export const GNode=({color}:Colorable)=><svg viewBox='0 0 1 1'>
    <circle r='0.505' cx='0.5' cy='0.5' fill={color}/>
</svg>

export const Bridge=({horiz='white',vert='white'}:{horiz?:string,vert?:string})=>
<svg viewBox= '0 0 1 1'>
    {/*outside */}
    <rect x='0' y='0' width='1' height='1' fill='gray'/>
    {/*paths */}
    <polygon points='0.4,0 0.4,0.4 0.6,0.6 0.6,1 0.4,1 0.4,0.6 0.6,0.4 0.6,0' fill={vert}/>
    <polygon points='0,0.4 0.4,0.4 0.6,0.6 1,0.6 1,0.4 0.6,0.4 0.4,0.6 0,0.6' fill={horiz}/>
    
</svg>
const PathFrags={down:PathDown,up:PathUp,left:PathLeft,right:PathRight}
export const Path=(args:Colorable&Directed)=>{
    let Bc:JSX.Element|undefined
    if(args.B){
        Bc=PathFrags[args.B](args)
    }
return <svg viewBox='0 0 1 1'>
    {Bc}{PathFrags[args.A](args)}
    <circle cx='0.5' cy='0.5' r='0.1' fill={args.color}/>
</svg>
}